import React from 'react';

import { i18n } from '../../translate/i18n';

import { Avatar, CardHeader, Grid, useTheme } from '@mui/material';

const TicketInfo = ({ contact, ticket, onClick }) => {
  const theme = useTheme();
  const renderCardReader = () => {
    return (
      <CardHeader
        onClick={onClick}
        avatar={<Avatar src={contact?.urlPicture} alt='contact_image' />}
        title={`${contact?.name || '(sem contato)'}  -  Atendimento: #${ticket.id}`}
        subheader={
          ticket.user &&
          `${i18n.t('messagesList.header.assignedTo')} ${ticket.user.name}`
        }
        sx={{
          marginLeft: -1,
          cursor: 'pointer',
        }}
        slotProps={{
          title: {
            noWrap: true,
            color: theme.custom.colors.text,
            fontSize: '16px',
            fontWeight: 700,
            whiteSpace: 'pre',
          },
          subheader: {
            noWrap: true,
            color: theme.custom.colors.text,
            fontSize: '12px',
            whiteSpace: 'pre',
          },
        }}
      />
    );
  };

  return (
    <React.Fragment>
      <Grid container alignItems='center' spacing={10}>
        {/* Conteúdo do contato à esquerda */}
        <Grid size={{ xs: 6 }}>{renderCardReader()}</Grid>
      </Grid>
    </React.Fragment>
  );
};

export default TicketInfo;
